import React from 'react'
import { Card as MCard, CardProps as MCardProps } from '@material-ui/core'

type CardProps = MCardProps

export default function Card (props: CardProps) {
  return (
    <MCard
      {...props}
    />
  )
}
